import { startTest } from '../util.js';
import './utilSpec.js';

startTest();
